module.exports = __webpack_public_path__ + "assets/img/tx21g_4.64fbb763.jpg";